module.exports = __webpack_public_path__ + "static/media/kaart_nl.fd03e7c8.svg";